import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";

export const useBudgetStates = (projectId: string | undefined) => {

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-budget-states", projectId],
        queryFn: () => commercialsApi.fetchBudgetStates(projectId),
    });

    return { data: data?.data || [], isLoading, isError, error };

};